import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BaseService } from './base.service';

export interface GameLevelResourceExerciseBankItem {
  /** game_level_resource.id；POST .../batch-delete 的 ids 即此主键 */
  id: number;
  /** game_level.id（列表展示/筛选用，删除接口不使用） */
  levelId?: number;
  levelName: string;
  questionContent: string | null;
  packageName: string;
  pathName: string | null;
  createdAt: string;
}

export interface GameLevelResourceExerciseBankPage {
  rows: GameLevelResourceExerciseBankItem[];
  total: number;
  pageIndex: number;
  pageSize: number;
}

export type ExerciseBankQuery = {
  pageIndex?: number;
  pageSize?: number;
  levelId?: number;
  rltSid?: number;
  exerciseId?: number;
};

export type BatchGameLevelResourceGroup = {
  rltSid: number;
  rltIds: number[];
};

export type BatchGameLevelResourcesPayload = {
  levelId: number;
  rltType: 'exercise' | 'quiz';
  resources: BatchGameLevelResourceGroup[];
};

export type BatchGameLevelResourcesResult = {
  insertedCount: number;
};

/** POST /game/level-resources/batch-delete — 按 game_level_resource.id 批量删除（见 game-level-resources-batch-delete-web-api.md） */
export type BatchDeleteGameLevelResourcesPayload = {
  ids: number[];
};

export type BatchDeleteResult = {
  deletedCount: number;
};

@Injectable({
  providedIn: 'root',
})
export class GameLevelResourceService extends BaseService {
  constructor(protected override http: HttpClient, protected override router: Router) {
    super(http, router);
  }

  /** GET /game/level-resources/exercise-bank */
  pageExerciseBank(query: ExerciseBankQuery): Promise<GameLevelResourceExerciseBankPage> {
    return this.get('/game/level-resources/exercise-bank', query);
  }

  /** POST /game/level-resources/batch */
  batchLevelResources(body: BatchGameLevelResourcesPayload): Promise<BatchGameLevelResourcesResult> {
    return this.post('/game/level-resources/batch', body);
  }

  /** POST /game/level-resources/batch-delete */
  batchDeleteByResourceIds(body: BatchDeleteGameLevelResourcesPayload): Promise<BatchDeleteResult> {
    return this.post('/game/level-resources/batch-delete', body);
  }
}
